import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';

const SectionDialog = ({
  visible,
  onHide,
  selectedClassForSection,
  classes,
  commonSections,
  selectedSectionNames,
  onSectionToggle,
  sectionTeacherMap,
  availableTeachers,
  onSectionTeacherChange,
  assignSection
}) => {
  const footer = (
    <div className="flex justify-between items-center mt-4">
      <Button label="Cancel" icon="pi pi-times" onClick={onHide} className="bg-black text-white rounded-lg px-4 py-2 hover:bg-gray-900 transition-all" />
      <Button label="Assign Section" icon="pi pi-check" onClick={assignSection} className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg px-4 py-2 shadow-md hover:shadow-lg transition-all" />
    </div>
  );

  return (
    <Dialog header="Assign Teachers to Sections" visible={visible} onHide={onHide} style={{ width: 540 }} footer={footer}>
      <div className="p-2 space-y-4">
        <div>
          <label className="block text-sm font-semibold">Class:</label>
          <Dropdown value={selectedClassForSection?.id} options={classes.map((c) => ({ label: c.name || `Class ${c.id}`, value: c.id }))} disabled placeholder="Class" className="w-full" style={{ opacity: 0.6 }} />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-3">Choose Sections and Assign Teachers:</label>
          <div className="grid grid-cols-1 gap-4 max-h-64 overflow-y-auto p-2 border rounded bg-gray-50">
            {commonSections.length === 0 ? (
              <div className="text-sm text-gray-500">No sections available.</div>
            ) : (
              commonSections.map((section) => (
                <div key={section.id} className="bg-white p-4 rounded-lg border border-gray-200">
                  <div className="flex items-center mb-3">
                    <Checkbox inputId={`sec-check-${section.id}`} checked={selectedSectionNames.includes(section.name)} onChange={(e) => onSectionToggle(e, section.name)} />
                    <label htmlFor={`sec-check-${section.id}`} className="ml-2 text-sm font-medium text-gray-700">section-{section.name}</label>
                  </div>
                  {selectedSectionNames.includes(section.name) && (
                    <div className="ml-6">
                      <label className="block text-xs font-medium text-gray-600 mb-2">Teacher:</label>
                      <Dropdown value={sectionTeacherMap[section.name] || null} options={availableTeachers.map((t) => ({ label: t.firstName || `Teacher ${t.id}`, value: t.id }))}
                        onChange={(e) => onSectionTeacherChange(section.name, e.value)} placeholder="Select a teacher" className="w-full text-sm" />
                    </div>
                  )}
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default SectionDialog;
